import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import pt from "./locales/ph.json";

i18n.use(initReactI18next).init({
  resources: {
    pt: { translation: pt },
    "pt-BR": { translation: pt },
    ar: { translation: pt },
    en: { translation: en },
  },
  lng: "pt",
  fallbackLng: "pt",
  interpolation: {
    escapeValue: false,
  },
});

i18n.dir = () => "ltr";

export default i18n;
